/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerContacts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Contacts
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 03, 2018 - 03:35:09 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      12/03/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    CONTACT_LIST_CONTAINER_LOADED,
    CONTACT_LIST_CONTAINER_UNLOADED,
    CONTACT_LIST_TABLE_LOADED,
    CONTACT_LIST_TABLE_UNLOADED,

    CONTACT_SELECT_ROW,
    CONTACT_ADD,
    CONTACT_EDIT,
    CONTACT_DELETE,
    CONTACT_OPEN_WARNING,
    CONTACT_CLOSE_WARNING,
    CONTACT_DELETE_DISABLE,

    CONTACT_SET_COMPANY_SELECT,

    CONTACT_EDIT_CONTAINER_LOADED,
    CONTACT_EDIT_CONTAINER_UNLOADED,
    CONTACT_EDIT_FORM_LOADED,
    CONTACT_EDIT_FORM_UNLOADED,
    CONTACT_EDIT_DATA_LOAD,
    CONTACT_EDIT_CONTAINER_SUBMIT,
    CONTACT_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeContacts';

const defaultState = {
    refreshList: false,
    danger: false,
    contactid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CONTACT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                contacts: action.payload[0] ? action.payload[0].records : null
            }
        case CONTACT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case CONTACT_SELECT_ROW:
            return {
                ...state,
                contactid: action.id
            }
        case CONTACT_ADD:
            return {
                ...state
            }
        case CONTACT_EDIT:
            return {
                ...state,
                contactid: action.id
            }
        case CONTACT_DELETE:
            return {
                ...state,
                contactid: null
            }
        case CONTACT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case CONTACT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case CONTACT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case CONTACT_EDIT_CONTAINER_LOADED:
        case CONTACT_EDIT_DATA_LOAD:
            return {
                ...state,
                contactid: action.payload[0] ? action.payload[0].contactid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                userid: action.payload[0] ? action.payload[0].userid : 0,
                titleid: action.payload[0] ? action.payload[0].titleid : 0,
                firstname: action.payload[0] ? action.payload[0].firstname : '',
                middlename: action.payload[0] ? action.payload[0].middlename : '',
                lastname: action.payload[0] ? action.payload[0].lastname : '',
                fullname: action.payload[0] ? action.payload[0].fullname : '',
                email: action.payload[0] ? action.payload[0].email : '',
                phone: action.payload[0] ? action.payload[0].phone : '',
                phonetype: action.payload[0] ? action.payload[0].phonetype : 0,
                avatarid: action.payload[0] ? action.payload[0].avatarid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case CONTACT_SET_COMPANY_SELECT:
            return {
                ...state,
                companySelect: action.payload ? action.payload : ''
            }
        case CONTACT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case CONTACT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case CONTACT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case CONTACT_LIST_CONTAINER_UNLOADED:
        case CONTACT_LIST_TABLE_UNLOADED:
        case CONTACT_EDIT_CONTAINER_UNLOADED:
        case CONTACT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerContacts.js